export enum AdminSettingsCacheKeys {
	AdminSearch = "_admin_search",
	AdminSearchResponse = "_admin_search_response",
	AdminSearchInvoked = "_admin_search_invoked"
}
